var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1C3.68632 1 1 3.68603 1 7C1 10.314 3.68632 13 7 13C10.3137 13 13 10.3134 13 7C13 3.6866 10.3137 1 7 1ZM7 10.2126C6.86194 10.2124 6.72707 10.1712 6.61241 10.0943C6.49776 10.0173 6.40847 9.90818 6.35584 9.78056C6.3032 9.65293 6.28957 9.51256 6.31668 9.37719C6.34379 9.24182 6.41041 9.11752 6.50813 9.02C6.60585 8.92248 6.73028 8.85611 6.86571 8.82928C7.00113 8.80245 7.14147 8.81636 7.269 8.86926C7.39652 8.92215 7.5055 9.01166 7.58217 9.12647C7.65884 9.24128 7.69976 9.37624 7.69976 9.5143C7.69976 9.60613 7.68165 9.69705 7.64647 9.78187C7.61128 9.86669 7.55972 9.94374 7.49472 10.0086C7.42972 10.0735 7.35257 10.1249 7.26768 10.1599C7.18279 10.1949 7.09183 10.2128 7 10.2126ZM7.69976 7.18812C7.69714 7.37196 7.62227 7.54739 7.49133 7.67646C7.3604 7.80554 7.18393 7.8779 7.00007 7.8779C6.81621 7.8779 6.63974 7.80554 6.50881 7.67646C6.37788 7.54739 6.303 7.37196 6.30038 7.18812V3.93074C6.303 3.7469 6.37788 3.57147 6.50881 3.4424C6.63974 3.31332 6.81621 3.24096 7.00007 3.24096C7.18393 3.24096 7.3604 3.31332 7.49133 3.4424C7.62227 3.57147 7.69714 3.7469 7.69976 3.93074V7.18812Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.f969c3b6073225dabfb86fd41dc08a99.svg";
export { ForwardRef as ReactComponent };